<template>
  <div>
    <el-form :inline="true" label-width="80px">
      <el-form-item label="生产队">
        <el-input v-model="queryInfo.teamName" clearable placeholder="请输入"/>
      </el-form-item>
      <el-form-item label="姓名">
        <el-input v-model="queryInfo.name" clearable placeholder="请输入"/>
      </el-form-item>
      <!-- <el-form-item label="户主">
        <el-input v-model="queryInfo.houseHolderName" clearable placeholder="请输入"/>
      </el-form-item> -->
      <el-form-item label="户主">
        <el-select
        v-model="queryInfo.houseHolderName"
        filterable
        clearable
        :remote-method="remoteMethod"
        remote>
          <el-option
          v-for="item in peopleList"
          :key="item.id"
          :label="item.farmerName"
          :value="item.farmerNo"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="身份证">
        <el-input v-model="queryInfo.idCardNo" clearable placeholder="请输入"/>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="query">查询</el-button>
      </el-form-item>
    </el-form>
    <table-list
    :loading="loading"
    :data="tableData"
    :page="page"
    :page-size="pageSize"
    :total="totalCount"
    :columnDefs="columnDefs"
    @pageChange="pageChange">
      <template #action={row}>
        <el-button type="text" size="small" @click="showAge(row)">审核</el-button>
      </template>
    </table-list>
    <el-dialog
    title="股份份额管理"
    :visible.sync="showShare"
    :before-close="closeInfo"
    center
    custom-class="age-dialog"
    destroy-on-close>
      <share-manage
      :farmerNo="farmerNo"
      :id="id"
      v-if="showShare"
      @closeInfo="closeInfo"
      @showUsed="showUsed"
      :usedId="usedId"/>
    </el-dialog>
    <!-- 上一次审批通过的农龄展示 -->
    <el-dialog
    title=""
    :visible.sync="showUsedData"
    :before-close="showUsed"
    center
    custom-class="age-dialog"
    destroy-on-close>
      <share-manage
      InfoType="details"
      :id="usedId"
      :farmerNo="farmerNo"
      v-if="showUsedData"
      />
    </el-dialog>
  </div>
</template>

<script>
import TableList from '@/components/TableList.vue'
import ShareManage from './shareManage.vue'
import { listStockWaitApproval, euFarmerInfoQuery } from '@/api/community.js'
export default {
  data () {
    return {
      queryInfo: {
        teamName: '',
        name: '',
        houseHolderName: '',
        idCardNo: ''
      },
      page: 1,
      pageSize: 10,
      totalCount: 0,
      tableData: [],
      loading: false,
      columnDefs: [
        { label: '姓名', prop: 'farmerName' },
        { label: '身份证号', prop: 'idCardNo' },
        { label: '总份额（股份）数量', prop: 'totalQuantity', width: 200 },
        { label: '总份额（股份）金额', prop: 'totalAmount', width: 200 },
        { label: '农龄份额（股份）数量', prop: 'farmerAgeQuantity', width: 200 },
        { label: '土地份额（股份）数量', prop: 'landQuantity', width: 200 },
        { label: '土地份额（股份）金额', prop: 'landAmount', width: 200 },
        { label: '人口份额（股份）数量', prop: 'populationQuantity', width: 200 },
        { label: '人口份额（股份）金额', prop: 'populationAmount', width: 200 },
        { label: '继承份额（股份）数量', prop: 'inheritQuantity', width: 200 },
        { label: '继承份额（股份）金额', prop: 'inheritAmount', width: 200 },
        { label: '其他份额（股份）数量', prop: 'otherQuantity', width: 200 },
        { label: '其他份额（股份）金额', prop: 'otherAmount', width: 200 },
        { label: '备注', prop: 'remark' },
        { label: '操作', prop: 'action' }
      ],
      showShare: false,
      showUsedData: false,
      usedId: '',
      farmerNo: '',
      id: '',
      peopleList: [],
      timer: null
    }
  },
  components: {
    TableList,
    ShareManage
  },
  methods: {
    showUsed () {
      this.showUsedData = !this.showUsedData
    },
    query() {
      this.page = 1
      this.getData()
    },
    getData () {
      listStockWaitApproval({
        ...this.queryInfo,
        pageSize: this.pageSize,
        pageNum: this.page,
      }).then(res => {
        const { code, result } = res
        if (code !== 0) return
        this.tableData = result.records
        this.totalCount = result.total
      })
    },
    showAge (row) {
      this.showShare = true
      this.farmerNo = row.farmerNo
      this.id = row.eventId
      this.usedId = row.stockApplyNo
    },
    closeInfo (refresh) {
      this.showShare = false
      this.id = ''
      if (refresh) {
        this.query()
      }
    },
    pageChange (page) {
      this.page = page
      this.getData()
    },
    getPeopleList (value) {
      euFarmerInfoQuery({
        pageNum: 1,
        pageSize: 100,
        name: value
      }).then(res => {
        const { code, result } = res
        if (code !== 0) return
        this.peopleList = result.records
      })
    },
    remoteMethod (value) {
      clearTimeout(this.timer)
      if (value) {
        this.timer = setTimeout(() => {
          this.getPeopleList(value)
        }, 500)
      } else {
        this.peopleList = []
      }
    }
  },
  mounted () {
    this.query()
  }
}
</script>
<style lang="scss" scoped>
/deep/ .age-dialog {
  min-width: 950px;
  width: 60%;
}
</style>